import { render, staticRenderFns } from "./ShopCard.vue?vue&type=template&id=3bad1210&scoped=true"
import script from "./ShopCard.vue?vue&type=script&lang=js"
export * from "./ShopCard.vue?vue&type=script&lang=js"
import style0 from "./ShopCard.vue?vue&type=style&index=0&id=3bad1210&prod&lang=css"
import style1 from "./ShopCard.vue?vue&type=style&index=1&id=3bad1210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bad1210",
  null
  
)

export default component.exports